import React from "react";
// import { Link } from 'react-router-dom';
import { motion } from "framer-motion";

import StrategicSessionBooking from "../Components/StrategicSessionBooking";
import ContactForm from "../Components/ContactForm";
import CustomCursor from "../Components/CustomCursor";

export default function PrivacyPolicy() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="bg-black text-white min-vh-100 "
    >
      <CustomCursor />

      <div className="container" style={{marginTop: '100px'}}>
        <div >
          <h4 className="ftfl0">Privacy Policy</h4>

          <p>
            At Dropshopi, we are committed to maintaining the privacy and
            security of your personal information. This Privacy Policy outlines
            how we collect, use, and protect your information when you visit our
            website or interact with our services.
          </p>

          <h6>Information We Collect</h6>
<p>We may collect the following types of personal data:</p>
<p><strong>Personal Information: </strong>Name, email address, phone number, and other contact details.</p>
<p><strong>Technical Information:</strong> IP address, browser type, device information, and browsing behavior on our website.
</p>
<p><strong>Transactional Data:</strong>Information related to purchases, payment details, and interactions with our customer support.
</p>
<p><strong></strong></p>


<h6>
    How We Use Your Information
</h6>
<p>We collect and use your personal information for the following purposes:
</p>

<ul>
    <li>We partner exclusively with driven entrepreneurs ready to scale fast and maximize ROAS with precision. Book Your Free Strategy Session Today and let’s take your brand to the next level.</li>
    <li>To provide and manage our products or services.
</li>
    <li>To communicate with you regarding updates, promotions, or support.
</li>
    <li>To improve our website and services based on your preferences and usage.
</li>
    <li>To comply with legal obligations and prevent fraudulent activity.
</li>
   
</ul>

<h5>
    Data Security
</h5>

<p>We are dedicated to protecting your personal information. We employ advanced security measures, including encryption and secure servers, to prevent unauthorized access or disclosure of your data. However, please note that no method of transmission over the internet or electronic storage is completely secure.

</p>

<h5>
    Cookies and Tracking Technologies

</h5>

<p>
    Our website uses cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and gather feedback. You can control cookie settings through your browser settings, but disabling cookies may affect your ability to use certain features of our site.

</p>
<h5>
    Your Rights
</h5>

<p>In accordance with applicable data protection laws, you have the following rights regarding your personal data:
</p>

<ul>
    <li><strong>Access: </strong>Request a copy of your personal data held by us.
</li>
    <li><strong>Correction: </strong>Request to correct inaccurate or incomplete information.
</li>
    <li><strong>Deletion: </strong>Request the deletion of your data, subject to certain legal conditions.
</li>
    <li><strong>Opt-Out: </strong>You may opt-out of receiving marketing communications at any time by following the unsubscribe link or contacting us directly.
</li>
</ul>
<p>
    To exercise these rights, please contact us using the details below.

</p>

<h5>Changes to This Policy
</h5>
<p>We reserve the right to update or modify this Privacy Policy at any time. Any changes will be posted on this page, and if significant, we will notify you via email or a prominent notice on our site. Please review this policy periodically for any updates.</p>


<h5>Contact Us</h5>
<p>If you have any questions or concerns regarding our Privacy Policy or the handling of your personal data, please contact us at:contact@dropshopi.com</p>

<hr className="mt-5"/>

<h5 className="ftfl0 mt-5">Terms and Conditions</h5>
<p>By using our website or services, you agree to comply with and be bound by the following Terms and Conditions. If you do not agree with these terms, please refrain from using our site.</p>


<h5>Use of the Website</h5>
<p>You may use our website for lawful purposes only and in accordance with these terms. You agree not to use the website for any activities that could harm or interfere with the operation of the site, including the distribution of harmful or illegal content.
</p>

<h5>Intellectual Property
</h5>
<p>All content on our website, including text, graphics, logos, and images, is protected by intellectual property laws. You are granted a limited, non-exclusive license to access and use the site for personal, non-commercial purposes.</p>


<h5>Limitation of Liability</h5>
<p>We are not liable for any damages resulting from your use of our website, including any loss of data, profits, or business interruption. We do not guarantee that our site will be error-free or uninterrupted</p>

<h5>Indemnification
</h5>
<p>You agree to indemnify and hold harmless [Your Company Name] and its affiliates from any claims, losses, or damages arising from your use of the website or violation of these terms.
</p>

<h5>Governing Law
</h5>
<p>These Terms and Conditions are governed by the laws of [Your Jurisdiction]. Any disputes arising out of or in connection with these terms shall be resolved in the courts of [Your Jurisdiction].
</p>

<h5>Contact Us</h5>
<p>For any questions or concerns about these Terms and Conditions, please contact us at:contact@dropshopi.com
</p>

<h5></h5>
<p></p>


<h5></h5>
<p></p>
        </div>
      </div>
    </motion.div>
  );
}
